var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",class:{hidden: _vm.Index > 0},attrs:{"data-target":_vm.Index}},[(_vm.IsBlackAndWhite == true)?_c('BlackAndWhite'):_c('Images',{attrs:{"Source":_vm.Source}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }